var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasAccess)?_c('router-view'):_c('PageLayout',{attrs:{"title":_vm.title}},[_c('PagePlaceholder',{attrs:{"config":_vm.placeholderConfig}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }